const SUBSCRIPTION_FEATURES = {
  free: [
    'Get monthly Experian Credit score updates.',
    'Monthly Experian Credit Report.',
    'Find out exactly when your score has changed and why.',
    'Check your eligibility before you apply for credit cards and personal loans.',
  ],
  creditExpert: [
    'Get daily score insights instead of monthly.',
    'See exactly what’s impacting your score.',
    'Build your score with actions tailored to you.',
    'Track progress with daily score updates.',
    'Daily online check for stolen details.',
    'Instant alerts when risks appear on your report.',
    'Speak to our experts for advice.',
  ],
  identityPlus: [
    'Get daily score insights instead of monthly.',
    'Monthly Experian Credit Report.',
    'Daily online check for stolen details.',
    'Get daily Experian Credit score updates.',
    'Dedicated support if you’re a victim of fraud.',
    'Steps to help protect your identity when you don’t recognise a change.',
    'Speak to our experts for advice.',
  ],
};

export const createSubscriptionConfig = (identityPrice, creditExpertPrice) => ({
  free: {
    title: 'Free Experian account',
    price: 'No charge',
    description: 'Use your existing login details to set up a free Experian account.',
    buttonText: 'Set up a free account',
    features: SUBSCRIPTION_FEATURES.free,
    buttonVariant: 'secondary',
  },
  identity: {
    title: 'Identity Plus subscription',
    price: identityPrice ? `£${identityPrice}` : null,
    frequency: 'month',
    description: 'Enjoy all the benefits of a Free account plus much more:',
    features: SUBSCRIPTION_FEATURES.identityPlus,
    buttonText: 'Restart Identity Plus',
    priceText: identityPrice ? `Price £${identityPrice} a month starting today` : null,
  },
  credit_expert: {
    title: 'CreditExpert subscription',
    price: creditExpertPrice ? `£${creditExpertPrice}` : null,
    frequency: 'month',
    highlight: 'CreditExpert customers are 3 times more likely to improve their score each month',
    description: 'Enjoy all the benefits of a Free account plus much more:',
    features: SUBSCRIPTION_FEATURES.creditExpert,
    buttonText: 'Restart CreditExpert',
    priceText: creditExpertPrice ? `Price £${creditExpertPrice} a month starting today` : null,
  },
});

export { SUBSCRIPTION_FEATURES };
